/**
 * Resolve Schedule a Tour CTA destinations.
 *
 * When a property has an AnyoneHome scheduler URL
 * (`custom_anyonehome_scheduler_url` — the same field AHScheduler embeds),
 * CTAs go to the Schedule a Tour page. Otherwise they fall through to Contact Us.
 * An editor-set URL on the slot group always wins.
 */

export const SCHEDULE_A_TOUR_PATH = '/schedule-a-tour';
export const CONTACT_US_PATH = '/contact-us';

/**
 * Upstream feeds sometimes pass literal strings like "false", "null", "none"
 * instead of an empty value — treat those as missing.
 */
export function isUsableUrl(value: string | null | undefined): boolean {
  if (!value) return false;
  const trimmed = value.trim();
  if (!trimmed) return false;
  const lower = trimmed.toLowerCase();
  if (
    lower === 'false' ||
    lower === 'true' ||
    lower === 'null' ||
    lower === 'undefined' ||
    lower === 'none' ||
    lower === 'n/a'
  ) {
    return false;
  }
  return true;
}

export function resolveScheduleTourHref(
  editorUrl: string | null | undefined,
  schedulerUrl: string | null | undefined,
): string {
  if (isUsableUrl(editorUrl)) return editorUrl!.trim();
  if (isUsableUrl(schedulerUrl)) return SCHEDULE_A_TOUR_PATH;
  return CONTACT_US_PATH;
}
